export function firstFiveWords(text: string | null | undefined): string | undefined {
  const words = String(text ?? "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (words.length === 0) return undefined;
  return words.slice(0, 5).join(" ");
}
